<template>
  <div id="app-team-invoices" class="account__article" style="display: none;">
    <div style="margin-bottom: 20px;" class="text-b85">It might take up to 5 hours for an invoice to generate. You can update your <a href="/account/team/details">billing details</a> and they will be reflected in your invoice.</div>
    <h2 class="text-3xl text-primary-offwhite font-light mb-4">
      Team Invoices
    </h2>
    <div
      id="content-header"
      class="w-full px-4 h-16 flex justify-between items-center bg-ma-gray-11"
    >
      <!--
			@Todo Enable later
			<date-picker
				v-model="dateRange"
				range
				:clearable="false"
				:editable="false"
				@change="onChangeDageRange"
			>
				<div slot="icon-calendar"></div>
				<div
					slot="input"
					class="text-ma-black-1 uppercase text-sm font-bold"
				>
					{{ dateRange && dateRange[0] | DATE("MMM, YYYY") }} -
					{{ dateRange && dateRange[1] | DATE("MMM, YYYY") }}
				</div>
			</date-picker>
			-->
    </div>
    <div id="content-body" class="w-full bg-white pb-2">
      <InvoiceTable :data="items" :header="header" />

      <div v-if="loading" class="w-full p-4 flex justify-center">
        <!-- loading pinner -->
        <div class="animation-spin btn-spinner">
          <i class="icon--spinner2"></i>
        </div>
      </div>
      <!-- TODO: pagnation -->
      <!-- <div
				v-else-if="total > page * itemsPerPage"
				class="w-full flex justify-center mb-2 sm:mb-0 sm:mt-2 sm:justify-start"
			>
				<div
					class="text-xs py-1 px-3 text-ma-gray-3 font-bold uppercase cursor-pointer hover:bg-ma-gray-0 sm:hover:text-ma-gray-1 sm:hover:bg-white"
					@click="onShowMore"
				>
					Show More
				</div>
			</div> -->
    </div>
  </div>
</template>

<script>
/* constants */
import { TEAM_INVOICES_TABLE_HEADER } from "@/constants";

/* vuex */
import { mapState } from "vuex";

/* components */
import InvoiceTable from "./components/InvoiceTable";
import DatePicker from "vue2-datepicker";
import "vue2-datepicker/index.css";

export default {
  components: {
    DatePicker,
    InvoiceTable,
  },
  metaInfo: () => ({
    title: "Team Invoices | Motion Array",
    link: [{ rel: "stylesheet", href: "/assets/site/css/team.css" }],
  }),
  data: () => ({
    header: TEAM_INVOICES_TABLE_HEADER,
    itemsPerPage: 15,
  }),
  computed: {
    ...mapState({
      teamInvoices: (state) => state.teamInvoices,
      items: (state) => state.teamInvoices.data,
      loading: (state) => state.teamInvoices.loading,
      total: (state) => state.teamInvoices.total,
      page: (state) => state.teamInvoices.page,
      error: (state) => state.teamInvoices.error,
    }),
    dateRange: {
      get() {
        return this.teamInvoices.dateRange;
      },
      set(val) {
        this.$store.dispatch("teamInvoices/setDateRange", val);
      },
    },
  },
  mounted() {
    document.querySelector('.account-links__container').parentElement.appendChild(this.$el)
    this.$el.style.display = null
    const dt = new Date();
    const date1 = dt.toISOString();
    dt.setMonth(dt.getMonth() - 1);
    const date0 = dt.toISOString();
    this.$store.dispatch("teamInvoices/setDateRange", [date0, date1]);
    this.getInvoices();
  },
  methods: {
    onShowMore() {
      this.getInvoices(true);
    },
    onChangeDageRange() {
      this.getInvoices();
    },
    /* API INTERACTIONS */
    async getInvoices(isNextPage) {
      const { dateRange, page, itemsPerPage } = this;
      const data = await this.$store.dispatch("teamInvoices/getInvoices", {
        page: isNextPage ? page + 1 : 1,
        dateRange,
        itemsPerPage,
      });
    },
  },
};
</script>

<style scoped>
#app-team-invoices {
}
</style>
